module.exports = __webpack_public_path__ + "img/cliff-outer.d8eee27f.png";